/**
 * Main Script File
 *
 * This is loaded in the footer of all pages. This is the preferred place to
 * load all script files.
 */

/**
 * Include default/js/components/processInclude.js when extending main.js per individual brand cartridge
 * var processInclude = require('../components/processInclude');
 */

/**
 * Add extending main.js functionality per individual brand cartridge
 * ie. processInclude(require('../product/quickViewBrand'));
 */

